import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import download from 'downloadjs';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from 'src/common/constants';
import { testOutput } from './test-output';

const ReportingSample = () => {
  const { signOut } = useAuthenticator((context) => [context.user]);
  const location = useLocation();
  const navigate = useNavigate();

  const [options, setOptions] = useState(['']);
  const [selectedVal, setSelectedVal] = useState('');

  const handleDownload = async () => {
    Auth.currentAuthenticatedUser().catch(() => {
      signOut();
      navigate(LOGIN_PATH, { replace: true, state: { from: location } });
    });
    try {
      const url = `${process.env.REACT_APP_API_GW_END_POINT}/${process.env.NODE_ENV}/report-quotation`;
      const jwtToken = (await Auth.currentSession()).getAccessToken().getJwtToken();

      // 出力ファイルを取得
      const res = await fetch(url, {
        method: 'POST',
        headers: { Authorization: jwtToken as string },
        body: JSON.stringify({
          template: selectedVal,
          rowCount: 36, // the count of detail lines
          data: testOutput,
        }),
      });

      if (res.status === 200) {
        // LocalにDownloadする
        const data = await res.blob();
        download(data, '12340001-01.pdf', 'application/pdf');
      } else {
        console.log('status', res.status);
        console.log('Timeout. Try again');
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const getReportFiles = async () =>
      await Auth.currentSession()
        .then((res) => {
          const jwtToken = res.getAccessToken().getJwtToken();
          // JwtTokenで保護されたLambdaにPostmanなどでアクセスする場合にAuthorizationが必要
          // development時はConsoleに出力するようにする
          if (process.env.NODE_ENV === 'development') console.log('jwtToken', jwtToken);
          const url = `${process.env.REACT_APP_API_GW_END_POINT}/${process.env.NODE_ENV}/get-report-template-files`;
          fetch(url, {
            method: 'GET',
            headers: { Authorization: jwtToken as string },
          })
            .then((res) => res.json())
            .then((items) => {
              setOptions(items);
              setSelectedVal(items[0]);
            });
        })
        .catch((err) => {
          signOut();
          navigate(LOGIN_PATH, { replace: true, state: { from: location } });
        });

    getReportFiles();
  }, []);

  return (
    <div>
      <select
        onChange={(e) => {
          setSelectedVal(e.target.value);
        }}
        value={selectedVal}
      >
        {options.map((el: string) => (
          <option key={el} value={el}>
            {el}
          </option>
        ))}
      </select>
      <button onClick={handleDownload}>Download PDF</button>
    </div>
  );
};

export default ReportingSample;
